<mat-tab-group>
	<mat-tab>
		<ng-template mat-tab-label>
			{{ locs.CMSystemLocalizationDialogEditSectionTitle | localize | async }}
		</ng-template>
		<ng-template matTabContent>
			<editor [(ngModel)]="locValue" [init]="tiny.CONFIG" [apiKey]="tiny.API_KEY" #editor id="tiny-input">
			</editor>
		</ng-template>
	</mat-tab>
	<mat-tab>
		<ng-template mat-tab-label>
			{{ locs.CMSystemLocalizationDialogDefaultValue | localize | async }}
		</ng-template>
		<ng-template matTabContent>
			<div [innerHTML]="defaultValue"></div>
		</ng-template>
	</mat-tab>
	<mat-tab>
		<ng-template mat-tab-label>
			{{ locs.CMSystemLocalizationDialogCurrentValue | localize | async }}
		</ng-template>
		<ng-template matTabContent>
			<div [innerHTML]="locValue"></div>
		</ng-template>
	</mat-tab>
</mat-tab-group>
